
import SingleSelectComponent from "../../../../components/single-select/single-select.component";
import goodMovementModel from "../../../../models/posm/goods-movement.model";
import ViewBase from "../../../view-base.view";
export default function StorageLocationSelect() {
  ViewBase.call(this);
  let wearhouseList = [];
  let storageLocationList = [];

  const getAllWareHouse = () => {
    goodMovementModel.getCommonForPopup({ DataType: 'POSM_WAREHOUSE', DataCode: '', DataName: '', ParameterDataCode: '' }).then((data) => {
      wearhouseList = data.data;
    }).catch((err) => {
      this.handleError(err);
    }).finally(
      () => {
        this.hideLoading();
      }
    );
  }
  const getAllStorageLocation = (wareHouseId) => {
    if (!wareHouseId) {
      return;
    }
    this.showLoading();
    goodMovementModel.getCommonForPopup({ DataType: 'POSM_STORAGE', DataCode: '', DataName: '', ParameterDataCode: wareHouseId }).then((data) => {
      storageLocationList = data.data;
    }).catch((err) => {
      this.handleError(err);
    }).finally(() => {
      this.hideLoading()
    })
  }
  return {
    oninit: () => {
      getAllWareHouse();
    },
    view: ({ attrs: { onSelect, selectedItem } }) => {
      return [
        m('.row.row-cols-5.g-2.align-items-center',
          m('.col.position-relative',
            m('label.form-label', this.getText('LT00001269', 'Warehouse')),
            m(SingleSelectComponent, {
              activeIndex: (wearhouseList.findIndex((item) => { return item.code == selectedItem.warehouse.code }) + 1) || 0,
              popoverAttrs: { class: 'posm-filters' },
              allowEmpty: wearhouseList.length != 0,
              items: wearhouseList,
              selectedItem: selectedItem.warehouse,
              checkmark: true,
              filterable: true,
              onSelect: (s) => {
                getAllStorageLocation(s.code);
                onSelect({ warehouse: s, storageLocation: { code: null, name: null } });
              },
            })
          ),
          selectedItem.warehouse.code && m('.col.position-relative',
            m('label.form-label', this.getText('LT00001270', 'Storage Location')),
            m(SingleSelectComponent, {
              activeIndex: (storageLocationList.findIndex((item) => { return item?.code == selectedItem.storageLocation.code }) + 1) || 0,
              popoverAttrs: { class: 'posm-filters' },
              allowEmpty: storageLocationList.length != 0,
              items: storageLocationList,
              selectedItem: selectedItem.storageLocation,
              checkmark: true,
              filterable: true,
              onSelect: (s) => { onSelect({ storageLocation: s }) },
            })
          )
        ),
        this.getBaseViews(),
      ]
    }
  }
}